import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { DeckHeightService } from '../services/deck-height.service';
import { AppStateService } from '../services/app-state.service';
import { HeightValidatorService } from '../services/height-validator.service';
import { StageService } from '../services/stage.service';
import { InputHeightValidatorDirective } from '../directives/input-height-validator.directive';
import { ToasterService } from 'angular2-toaster';
import {EventLogService, Actions} from '../services/eventLog';

declare let THREE: any;

@Component({
  selector: 'app-set-height',
  templateUrl: './set-height.component.html',
  styleUrls: ['./set-height.component.scss']
})
export class SetHeightComponent implements OnInit {

  @Output() step1Editer = new EventEmitter();

  private _deckHeightSubscribtion;
  private _sizeUnitsSubscribtion;

  public sizeUnits: string = 'imperial';
  private feetInput: number = 0;
  private inchInput: number = 0;
  private meterInput: number = 0;
  private cmInput: number = 0;
  private inputHeightValidatorDirective: InputHeightValidatorDirective;

  goBack(value) {
    this.step1Editer.emit({ name: value });
  }

  constructor(
    private deckHeightService: DeckHeightService,
    private appStateService: AppStateService,
    private stageService: StageService,
    private heightValidatorService: HeightValidatorService,
    private toasterService: ToasterService,
    private eventLogService: EventLogService
  ) {
  }

  changeFtValidate(value) {
    let numbValue: number = +value;
    let deckHeight;
    if (this.heightValidatorService.checkChangeHeightValidate(this.feetInput, this.inchInput)) {
      if (numbValue < 0) {
        this.feetInput = 0;
        deckHeight = this.feetInput * 12 + this.inchInput;
      }
      else {
        this.feetInput = numbValue;
        // console.log(this.feetInput);
        deckHeight = this.feetInput * 12 + this.inchInput;
      }
      this.updateProj(deckHeight);
    }
  }

  changeInchValidate(value) {
    let numbValue: number = +value;
    let deckHeight;
    if (this.heightValidatorService.checkChangeHeightValidate(this.feetInput, this.inchInput)) {
      if (numbValue < 0) {
        this.inchInput = 0;
        deckHeight = this.feetInput * 12 + this.inchInput;
      }
      else if (numbValue >= 12) {
        let Ft = Math.floor(numbValue / 12);
        this.feetInput += Ft;
        this.inchInput = numbValue % 12;
        deckHeight = this.feetInput * 12 + this.inchInput;
      } else {
        this.inchInput = numbValue;
        deckHeight = this.feetInput * 12 + this.inchInput;
      }
      this.updateProj(deckHeight);
    }
  }

  changeCMValidate(value) {
     let deckHeight;
    if (value < 0) {
      let cm = this.cmInput;
      deckHeight = cm * 0.393700787;
    }
    else {
      this.cmInput = value;
      let cm = this.cmInput;
      deckHeight = cm * 0.393700787;
    }
    this.updateProj(deckHeight);
  }

  incrementFeetInput() {
    this.feetInput++;
    const inchInput: number = +this.inchInput;
    const deckHeight = this.feetInput * 12 + inchInput;
    this.updateProj(deckHeight, 30.48);
  }

  dencrementFeetInput() {
    if (this.feetInput > 0 && this.heightValidatorService.checkDecrFeet()) {
      this.feetInput--;
      const inchInput: number = +this.inchInput;
      const deckHeight = this.feetInput * 12 + inchInput;
      this.updateProj(deckHeight, -30.48);
    } else {
      this.showToast('warning', 'Invalid value', 'Minimal height exceeded');
    }
  }

  incrementInchInput() {
    if (this.inchInput === 11) {
      this.feetInput++;
      this.inchInput = 0;
    } else {
      this.inchInput++;
      const inchInput: number = +this.inchInput;
      const deckHeight = this.feetInput * 12 + inchInput;
      this.updateProj(deckHeight, 2.54);
    }
  }

  dencrementInchInput() {
    if ((this.inchInput > 8 || this.feetInput > 0) && this.heightValidatorService.checkDecrInch()) {
      if (this.inchInput > 0) {
        this.inchInput--;
        const inchInput: number = +this.inchInput;
        const deckHeight = this.feetInput * 12 + inchInput;
        this.updateProj(deckHeight, -2.54);
      } else {
        this.feetInput--;
        this.inchInput = 11;
      }
    } else {
      this.showToast('warning', 'Invalid value', 'Minimal height exceeded');
    }
  }

  incrementCMInput() {
    this.cmInput++;
    let cm = this.cmInput;
    let deckHeight = cm * 0.393700787;
    this.updateProj(deckHeight);
  }

  dencrementCMInput() {
    if (this.cmInput > 0) {
      this.cmInput--;
      let cm = this.cmInput;
      let deckHeight = cm * 0.393700787;
      this.updateProj(deckHeight);
    }
  }

  updateProj(deckHeight: number, rascaleWallValue: number = 0): void {
    this.eventLogService.dispatch(new Actions.SetHeightAction(deckHeight, rascaleWallValue));
  }

  getTiersHeight() {
    const oneFeetInCm = 30.48, oneInchInCm = 2.54;
    let logs = this.stageService.getCompoundFloor().children.map(element => element.getWorldPosition(new THREE.Vector3()).y);
    let minHeight = Math.max.apply(null, logs) - Math.min.apply(null, logs);
    let heightInput = this.feetInput * 30.48 + this.inchInput * 2.54;
    if (logs.every(function (element) { return (element - oneFeetInCm) >= 20.32; })) {
      return true;
    }
    else {
      // console.log(Math.min.apply(null, logs));
      return false;
    }
  }

  private checkChangeInputFt() {
    let elementsHeight = this.stageService.getCompoundFloor().children.map(element => element.getWorldPosition(new THREE.Vector3()).y);
    let minHeight = Math.max.apply(null, elementsHeight) - Math.min.apply(null, elementsHeight);
    let start: number = 0;
    let end: number = 8;
    let b = new RegExp(`[${start}-${end}]`);
  }

  ngOnInit() {
    this._deckHeightSubscribtion = this.deckHeightService.deckHeightChange.subscribe(value => {

      if (this.sizeUnits === 'imperial') {
        this.feetInput = Math.floor(value / 12);
        this.inchInput = +(value % 12).toFixed(0);
      }
      else {
        let cm = value * 2.54;
        // this.meterInput = Math.floor(cm / 100);
        this.cmInput = +cm.toFixed(0);
      }
    });

    this._sizeUnitsSubscribtion = this.appStateService.sizeunitsChange.subscribe(value => {

      if (this.sizeUnits !== value) {
        this.sizeUnits = value;
        if (value === 'imperial') {
          let cm = this.cmInput;
          let inch = cm * 0.393700787;
          this.feetInput = Math.floor(inch / 12);
          this.inchInput = +(inch % 12).toFixed(0);
        } else {
          let inch = this.inchInput + this.feetInput * 12;
          let cm = inch * 2.54;
          // this.meterInput = Math.floor(cm * 10);
          this.cmInput = +cm.toFixed(0);
        }
      }
    });
  }
  showToast(type: string, title: string, body: string) {
    this.toasterService.popAsync(type, title, body);
  }
}



// WEBPACK FOOTER //
// ./src/app/set-height/set-height.component.ts